import { initSentry } from "./helpers/sentry";
initSentry('client');